import type { RouteRecordRaw } from "vue-router";

export const videoRecorderRoutes: RouteRecordRaw[] = [
  {
    path: "/video_recorder/info",
    name: "video_recorder-info",
    component: () => import("./info/VideoRecorderInfoPage.vue"),
    meta: {
      namespace: "video_recorder",
      title: "tools_meta.video_recorder_prefix",
    },
  },
  {
    path: "/video_recorder/files",
    name: "video_recorder-index",
    component: () => import("./files/VideoFileListPage.vue"),
    meta: {
      requiresAuth: true,
      namespace: "video_recorder",
      title: "tools_meta.video_recorder_prefix",
    },
  },
  {
    path: "/video_recorder/files/:id",
    name: "video_recorder-show",
    component: () => import("./files/VideoFileLayout.vue"),
    meta: {
      requiresAuth: true,
      namespace: "video_recorder",
      title: "tools_meta.video_recorder_prefix",
    },
    children: [
      {
        path: "settings",
        name: "video_recorder-settings",
        component: () => import("./files/[id]/settings.vue"),
        meta: {
          requiresAuth: true,
          namespace: "video_recorder",
          title: "tools_meta.video_recorder_prefix",
        },
      },
      {
        path: "share",
        name: "video_recorder-share",
        component: () => import("./files/[id]/share.vue"),
        meta: {
          requiresAuth: true,
          namespace: "video_recorder",
          title: "tools_meta.video_recorder_prefix",
        },
      },
    ],
  },
  {
    path: "/video_recorder/public_files/:id",
    name: "video_recorder-public-show",
    component: () => import("./public_files/[id]/PublicVideoFilePage.vue"),
    meta: {
      namespace: "video_recorder",
      title: "tools_meta.video_recorder_prefix",
    },
  },
];
